import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from '../../../providers/api.service';
import { SM_CONSTANTS } from '../../constants/sm-constants';
@Component({
  selector: 'sm-blocked-accounts-details',
  templateUrl: './blocked-accounts-details.component.html',
  styleUrls: ['./blocked-accounts-details.component.scss']
})
export class BlockedAccountsDetailsComponent implements OnInit {

 
  imageUrl: string = environment.profileImageBaseUrl;
  metadata: any
  postData: any
  businessData: any
  public loader: boolean = false;
  private _apiSubscription: Subscription;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private _apiService: ApiService) {

    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
      if(resData.responseType === SM_CONSTANTS.GET_USER_DETAIL_RESULT){
      console.log(resData.result);
      resData.result.addressInfo = JSON.parse(resData.result.addressInfo)

        this.metadata = resData.result
      
        
      }
      if(resData.responseType === SM_CONSTANTS.GET_POST_DETAIL_RESULT){
      console.log(resData.result);
        this.postData = resData.result
      
        
      }
      if(resData.responseType === SM_CONSTANTS.GET_ENTITY_DETAILS_RESULT){
        console.log(resData.result);
        resData.result[0].addressInfo = JSON.parse(resData.result[0].addressInfo)
   
        
          this.businessData = resData.result
        
          
        }
      this.loader = false;
    });
   }

  ngOnInit(): void {
    console.log(this.data);
    
this.loader = true


    
      if(this.data.type == 'user'){
        console.log(this.data.hash_id);
        
        this._apiService.getUserDetail(this.data.hash_id)
      }
      if(this.data.type == 'business'){
        console.log(this.data.hash_id);
        this._apiService.getEntityDetails(this.data.hash_id)
      }
  
    
  }
  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe()
  }

}
